var _linearGradient, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebnew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Orange_Yellow",
    gradientUnits: "userSpaceOnUse",
    x1: 0.434,
    x2: 27.194,
    y1: 31.094,
    y2: 5.145
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff33b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#fee72e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#fed51b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#fdca10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#fdc70c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#f3903f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#ed683c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e93e3a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16 1a15 15 0 1 0 15 15 15.017 15.017 0 0 0 -15-15zm0 28c-2.065 0-4.227-2.662-5.3-7h10.6c-1.073 4.338-3.235 7-5.3 7zm-5.706-9a27.358 27.358 0 0 1 0-8h11.412a26.651 26.651 0 0 1 .294 4 26.651 26.651 0 0 1 -.294 4zm-7.294-4a12.94 12.94 0 0 1 .636-4h4.65a28.115 28.115 0 0 0 0 8h-4.65a12.94 12.94 0 0 1 -.636-4zm13-13c2.065 0 4.227 2.662 5.3 7h-10.6c1.073-4.338 3.235-7 5.3-7zm7.714 9h4.65a12.9 12.9 0 0 1 0 8h-4.65a28.351 28.351 0 0 0 .286-4 28.351 28.351 0 0 0 -.286-4zm3.807-2h-4.167a16.766 16.766 0 0 0 -2.567-6.075 13.063 13.063 0 0 1 6.734 6.075zm-16.308-6.075a16.766 16.766 0 0 0 -2.567 6.075h-4.167a13.063 13.063 0 0 1 6.734-6.075zm-6.734 18.075h4.167a16.766 16.766 0 0 0 2.567 6.075 13.063 13.063 0 0 1 -6.734-6.075zm16.308 6.075a16.766 16.766 0 0 0 2.567-6.075h4.167a13.063 13.063 0 0 1 -6.734 6.075z",
    fill: "url(#Orange_Yellow)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebnew);
export default __webpack_public_path__ + "static/media/webnew.621e5c2ad1c989cd5a41b3afaca37b5c.svg";
export { ForwardRef as ReactComponent };